import { useDetail, useList } from '@inmagik/react-crud'
import { fetchApi, useDataFetchingAuth } from '@inmagik/react-crud/dist/crud/utils'
import { useMutation, useQueryClient, UseQueryOptions } from '@tanstack/react-query'
import { API_URL } from '../constants'
import { NotificaClienteType } from '../typesCliente'
import { useData } from './useData'

// #region AREA CLIENTE
export function useNotificaList(params: Record<string, string> = {}) {
  return useList<NotificaClienteType>(`${API_URL}/bilance/notifica`, params)
}

export function useNotifica(id: string, enabled: boolean = true) {
  return useDetail<NotificaClienteType>(`${API_URL}/bilance/notifica`, id, { enabled })
}

export function useUnreadNotificheCount(
  queryParams: Omit<UseQueryOptions<{ unread_count: number }, Error>, 'queryKey' | 'queryFn'>
) {
  return useData<{ unread_count: number }>(`${API_URL}/bilance/notifica/unread-count`, { reactQuery: queryParams })
}

export function useReadNotifica() {
  const client = useQueryClient()
  const authHeaders = useDataFetchingAuth()

  return useMutation({
    mutationFn: ({ notificaId, letta }: { notificaId: NotificaClienteType['id']; letta: boolean }) => {
      const apiUrl = `${API_URL}/bilance/notifica/${notificaId}/read/`
      const fd = new FormData()
      fd.append('letta', letta.toString())
      return fetchApi(apiUrl, {
        method: 'PATCH',
        headers: authHeaders,
        body: fd,
      })
    },
    onSuccess: (_result, variables) => {
      client.invalidateQueries({ queryKey: [`${API_URL}/bilance/notifica`] })
      client.invalidateQueries({ queryKey: [`${API_URL}/bilance/notifica`, variables.notificaId] })
      client.invalidateQueries({ queryKey: [`${API_URL}/bilance/notifica/unread-count`] })
    },
  })
}
